"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPicker = void 0;
var _loggingStateService = require("@smartsheet/logging-state-service");
var _react = _interopRequireWildcard(require("react"));
var _logging = require("../../../util/logging");
var _ColorSelector = require("../ColorSelector");
var _CustomColorPicker = require("../CustomColorPicker");
var _warnOnLocaleProp = require("../colorPickerUtils/warnOnLocaleProp");
const warnOnNoLocaleProp = (0, _warnOnLocaleProp.makeWarnOnLocaleProp)("ColorPicker");

// Fancy props (i.e. w/ the fancy object return)

// Union'd type that can discriminate based on the type given to the
// react component when it's used!
const ColorPicker = props => {
  const {
    className,
    color,
    customColors = [],
    automaticColor,
    showCustom,
    locale = "en",
    onCustomColorsChange,
    clientId,
    showOpacity,
    standardColorPalette,
    maxCustomColors
  } = props;
  if (process.env.NODE_ENV !== "production") {
    if (typeof props.locale !== "string") {
      warnOnNoLocaleProp();
    }
  }
  const [mode, setMode] = (0, _react.useState)("basic");
  const [custColors, setCustomColors] = (0, _react.useState)(customColors);
  const logger = (0, _react.useContext)(_loggingStateService.LoggerContext);
  const withLogging = new _logging.LoggingDecorator(logger, {
    clientId,
    controlType: "cpp"
  });
  const loggerContent = {
    actionId: _loggingStateService.LogActionId.CLICK
  };
  const onChange = value => {
    switch (props.forceReturnType) {
      case "rgba":
        void withLogging.enabledByDefault(loggerContent, props.onChange)(value.rgba);
        break;
      case "hex":
        void withLogging.enabledByDefault(loggerContent, props.onChange)(value.hex);
        break;
      case "full":
        void withLogging.enabledByDefault(loggerContent, props.onChange)(value);
        break;
      default:
        void withLogging.enabledByDefault(loggerContent, props.onChange)(value.a !== undefined && value.a < 1 ? value.rgba : value.hex);
        break;
    }
  };
  const onAddCustomColor = value => {
    // TODO shouldn't this be an array of the return types as well?
    const newColors = custColors.concat([value.a !== undefined && value.a < 1 ? value.rgba : value.hex]);
    const existingColor = custColors.find(c => c.toLowerCase() === value.hex || c === value.rgba);
    if (!existingColor) {
      setCustomColors(newColors);
      onCustomColorsChange && void withLogging.enabledByDefault(loggerContent, onCustomColorsChange)(newColors);
    } else {
      if (color.toLowerCase() !== value.hex.toLowerCase() && color !== value.rgba) onChange(value);
    }
    setMode("basic");
  };
  const onRemoveCustomColor = value => {
    const newColors = custColors.filter(clr => clr !== value);
    setCustomColors(newColors);
    onCustomColorsChange && void withLogging.enabledByDefault(loggerContent, onCustomColorsChange)(newColors);
  };
  const setAdvancedMode = () => {
    setMode("advanced");
    void withLogging.enabledByDefault(loggerContent, () => {})();
  };
  const setBasicMode = () => {
    setMode("basic");
    void withLogging.enabledByDefault(loggerContent, () => {})();
  };
  return mode === "basic" ? /*#__PURE__*/_react.default.createElement(_ColorSelector.ColorSelector, {
    className: className,
    automaticColor: automaticColor,
    showCustom: showCustom,
    customColors: custColors,
    currentColor: color,
    onChange: onChange,
    onAddButtonClick: setAdvancedMode,
    onRemoveCustomColor: onRemoveCustomColor,
    clientId: clientId,
    locale: locale,
    forceReturnType: "full",
    standardColorPalette: standardColorPalette,
    maxCustomColors: maxCustomColors
  }) : /*#__PURE__*/_react.default.createElement(_CustomColorPicker.CustomColorPicker, {
    className: className,
    color: color,
    onCancel: setBasicMode,
    onApply: onAddCustomColor,
    clientId: clientId,
    locale: locale,
    showOpacity: showOpacity,
    forceReturnType: "full"
  });
};
exports.ColorPicker = ColorPicker;
//# sourceMappingURL=ColorPicker.js.map